<template>
  <div class="pt-2 ml-4 circle">
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
  .circle {
    background-color: var(--grey);
    height: 30px;
    width: 30px;
    border-radius: 50%;
    text-align: center;
    color: white;
  }
</style>
